import React from "react";
import "../style/AllProducts.css"; // Import the CSS file
import { ProductsList } from "../source/productsList";
import { CentersList } from "../source/centersList";

const AllProducts = () => {
  return (
    // <div className="container">

    //   <div className="breadcrumb">Home &gt;  Training Centers</div>

    //   {CentersList.map((product) => {
    //     return (
    //       <div className="all-products-container">
    //         {/* Product Image Section */}
    //         {/* <div className="product-image-section">
    //           <img
    //             src={product.image}
    //             alt="Laser Beam Detector"
    //             className="product-image"
    //           />
    //         </div> */}

    //         {/* Product Info Section */}

    //         {/* Right: Contact Info */}
    //         <div className="contact-info">
    //           <h3>Get in Touch</h3>
    //           <p><strong>📍 Address:</strong> Golden I Greater Noida West 201301, India.</p>
    //           <p><strong>📧 Email:</strong> info@jlgv.in</p>
    //           <p><strong>📞 Phone:</strong> +91-7217895839</p>

    //           {/* Google Map Embed */}
    //           <div className="map">
    //             <iframe
    //               title="ASR Academey"
    //               src="https://maps.google.com/maps?q=Greater+Noida+West&t=&z=13&ie=UTF8&iwloc=&output=embed"
    //               allowFullScreen
    //               loading="lazy"
    //             ></iframe>
    //           </div>
    //         </div>
    //       </div>
    //     )
    //   })}
    // </div>

    <div className="contact-page">

      {/* Left: Contact Form */}

      {CentersList.map((product) => {
        return (
          <div className="contact-container">
            <div className="product-info">
            <h2>{product.header}</h2>

              {/* Product Specifications */}
              <table className="product-table">
                <tbody>
                  {/* <tr>
                    <td className="label">Contact Person</td>
                    <td className="value">{product.contactPerson}</td>
                  </tr> */}
                  <tr>
                    <td className="label">Phone:</td>
                    <td className="value">{product.contactNumber}</td>
                  </tr>
                  <tr>
                    <td className="label">Email:</td>
                    <td className="value">{product.email}</td>
                  </tr>
                  <tr>
                    <td className="label">Address:</td>
                    <td className="value">{product.address}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="contact-info">
              <h3>Get in Touch</h3>
              {/* <p><strong>📍 Address:</strong> {product.address}</p> */}

              {/* Google Map Embed */}
              <div className="map">
                <iframe
                  title="ASR Academey"
                  src={product.src} 
                  allowFullScreen
                  loading="lazy"
                ></iframe>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  );
};

export default AllProducts;


// import React from "react";
// import "../style/AllProducts.css"; // Import the CSS file
// import { ProductsList } from "../source/productsList";

// const AllProducts = () => {
//   return (
//     <div className="container">

//       <div className="breadcrumb">Home &gt;  Training Centers</div>

//       {ProductsList.map((product) => {
//         return (
//           <div className="all-products-container">
//             {/* Product Image Section */}
//             <div className="product-image-section">
//               <img
//                 src={product.image}
//                 alt="Laser Beam Detector"
//                 className="product-image"
//               />
//               <span className="image-hover-label">🔍 Hover to zoom</span>
//             </div>

//             {/* Product Info Section */}
//             <div className="product-info">
//               <h2 className="product-title">{product.name}</h2>
//               <button className="get-price-btn">Get Best Price</button>

//               <p className="product-details">
//                 MOQ: <span>{product.moq}</span>
//               </p>

//               {/* Product Specifications */}
//               <table className="product-table">
//                 <tbody>
//                   <tr>
//                     <td className="label">Business Type</td>
//                     <td className="value">{product.bussType}</td>
//                   </tr>
//                   <tr>
//                     <td className="label">Body Material</td>
//                     <td className="value">{product.material}</td>
//                   </tr>
//                   <tr>
//                     <td className="label">Color</td>
//                     <td className="value">{product.color}</td>
//                   </tr>
//                   <tr>
//                     <td className="label">Shape</td>
//                     <td className="value">{product.shape}</td>
//                   </tr>
//                   <tr>
//                     <td className="label">Category</td>
//                     <td className="value">{product.categ}</td>
//                   </tr>
//                   <tr>
//                     <td className="label">Usage/Application</td>
//                     <td className="value">{product.usage}</td>
//                   </tr>
//                   <tr>
//                     <td className="label">Operating Voltage</td>
//                     <td className="value">{product.voltage}</td>
//                   </tr>
//                   <tr>
//                     <td className="label">Country of Origin</td>
//                     <td className="value">{product.origin}</td>
//                   </tr>
//                 </tbody>
//               </table>

//               {/* Preferred Buyer Section */}
//               <div className="preferred-buyer">
//                 <p>Preferred Buyer From</p>
//                 <p style={{fontWeight: 200}}>Anywhere in India</p>
//               </div>

//               {/* Interest Button */}
//               <button className="interest-btn">Yes! I am interested</button>
//             </div>
//           </div>
//         )
//       })}
//     </div>
//   );
// };

// export default AllProducts;
